import React, { memo, useEffect } from "react";
import ConnectionList from "./ConnectionList";
import ChatList from "./ChatList";
import { BsChatSquareText } from "react-icons/bs";
import { BiUserPin } from "react-icons/bi";
import { StyledChatSidebarTabs, StyledTabItem } from "../index.styled";
import IntlMessages from "@lib/helpers/IntlMessages";
import { useNavigate, useParams } from "react-router-dom";

type UserTabsProps = {
  chatListData: any[];
  isLoading: boolean | undefined;
};

const UserTabs: React.FC<UserTabsProps> = ({
  chatListData = [],
  isLoading,
}) => {
  const { tabId } = useParams();
  const navigate = useNavigate();

  const handleTabChange = (key: string) => {
    navigate(`/messages/telegram/${key}`);
  };

  useEffect(() => {
    if (!tabId) {
      handleTabChange(items[0].key);
    }
  }, [tabId]);

  const items = [
    {
      label: (
        <StyledTabItem onClick={() => handleTabChange("messages")}>
          <BsChatSquareText />
          {<IntlMessages id="common.messages" />}
        </StyledTabItem>
      ),
      key: "messages",
      children: <ChatList chatListData={chatListData} loading={isLoading} />,
    }, // remember to pass the key prop
    {
      label: (
        <StyledTabItem onClick={() => handleTabChange("connections")}>
          <BiUserPin />
          {<IntlMessages id="common.contacts" />}
        </StyledTabItem>
      ),
      key: "connections",
      children: <ConnectionList />,
    },
  ];

  return (
    <StyledChatSidebarTabs
      defaultActiveKey={tabId || "messages"}
      items={items}
    />
  );
};

export default memo(UserTabs);
